export default "__VITE_ASSET__726cc406__"